// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3Y7iX","info":"Note_info__2bzYW","note":"Note_note__1-ASE","actions":"Note_actions__bBRDC"};